import React from 'react';
import { Translate } from 'react-localize-redux';
import {
  arrayOf, func, bool
} from 'prop-types';
import { withLang, langType } from '../../../../i18n';
import { surveySchemaMetadataType } from '../../../../constants/types';
import SchemaPartDragDrop from '../SchemaPartDragDrop';

const SelectedSurveySchemaParts = ({
  lang,
  schemaParts,
  selectOne,
  onRemoveSchemaPart,
  onUpdateSchemaParts,
  translate: t
}) => {
  const noSelectedSchemaPartMessageKey = selectOne
    ? 'surveySchemaParts.noSelectedSchemaPart'
    : 'surveySchemaParts.noSelectedSchemaParts';

  return (
    <div>
      {selectOne
        ? <h3><Translate id="surveySchemaParts.selectedSchemaPartTitle" /></h3>
        : <h3>{schemaParts.length} <Translate id="surveySchemaParts.schemaPartCount" /></h3>}
      {schemaParts.length > 0
        ? (
          <SchemaPartDragDrop
            currentLanguage={lang}
            schemaParts={schemaParts}
            onRemoveSchemaPart={onRemoveSchemaPart}
            updateSchemaParts={onUpdateSchemaParts}
            lockedFromEditing={false}
            onUpdateSchemaPartVersion={() => {}}
          />
        )
        : <>{t(noSelectedSchemaPartMessageKey)}</>}
    </div>
  );
};

SelectedSurveySchemaParts.propTypes = {
  schemaParts: arrayOf(surveySchemaMetadataType).isRequired,
  onRemoveSchemaPart: func.isRequired,
  onUpdateSchemaParts: func,
  selectOne: bool,
  ...langType
};

SelectedSurveySchemaParts.defaultProps = {
  selectOne: false,
  onUpdateSchemaParts: () => {}
};

export default withLang(
  SelectedSurveySchemaParts
);
